import { DrawerPanel } from '@dmc/ui';
import DiscardFormDialog from '@casops/dialogs/discard-form-dialog/DiscardFormDialog';
import { useDiscardFormDialog } from '@casops/dialogs/discard-form-dialog/useDiscardFormDialog';
import { HOME_OVERVIEW_GEOFENCES } from '@casops/navigation';
import GeofenceForm from '@casops/side-panels/manage-geofence/components/form/GeofenceForm';
import { useLoadGeofenceDataDependencies } from '@casops/side-panels/manage-geofence/useLoadGeofenceDataDependencies';
import { ModelName } from '@casops/store/api';
import { VdsButton } from '@volt/volt-extended-components-react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export const CreateGeofence = (): ReactElement => {
  const { t } = useTranslation();

  const { isLoaded, renderKey } = useLoadGeofenceDataDependencies({ isItemLoaded: true });

  const { dialogRef, onCancel, onDiscard, leaveView, setIsFormDirty } = useDiscardFormDialog({
    navigateTo: HOME_OVERVIEW_GEOFENCES,
  });

  return (
    <>
      <DrawerPanel
        isLoaded={isLoaded}
        header={t('GeofenceProperties')}
        fillSidePanel={false}
        footer={
          <VdsButton variant="ghost" size="medium" disabled={false} isFullWidth onClick={onCancel}>
            {t('Cancel')}
          </VdsButton>
        }
      >
        <GeofenceForm
          key={renderKey}
          item={undefined}
          editMode={false}
          customSuccessCallback={leaveView}
          setIsFormDirty={setIsFormDirty}
        />
      </DrawerPanel>
      <DiscardFormDialog
        elementRef={dialogRef}
        modelName={ModelName.Geofence}
        onDiscard={onDiscard}
      />
    </>
  );
};

export default CreateGeofence;
